import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallFiltersDialog from "./CallFiltersDialog";
import { displayMultiSelect } from "../Utility/ChipDisplay";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface ICallFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function CallFilters({ callTableViewModel, setCallTableViewModel }: ICallFiltersProps) {
    const [open, setOpen] = useState(false);


    const secondsToMinutes = (value: number) => {
        const minutes = Math.floor(value / 60);
        const seconds = value - minutes * 60;
        let secondsString;
        if (seconds < 10) {
            secondsString = '0' + seconds;
            return minutes + ":" + secondsString;
        }

        return minutes + ":" + seconds;
    }

    const text =
        <Typography variant="body1">
            {
                'Call'
            }
            {
                callTableViewModel.filters.callFilters.result.length === 0 ? '' :
                    callTableViewModel.filters.callFilters.resultExclude ? ' - Result Exclude' : ' - Result Include'
            }
            {
                displayMultiSelect(callTableViewModel.filters.callFilters.result, 'Result')
            }
            {
                callTableViewModel.filters.callFilters.resultSource ? ` - ${callTableViewModel.filters.callFilters.resultSource}` : ''
            }
            {
                callTableViewModel.filters.callFilters.systemID ? ` - ${callTableViewModel.filters.callFilters.systemID}` : ''
            }
            { //if the call falg is pressed conver the min and max values to their text equivelent and display * if both values match
                callTableViewModel.filters.callFilters.isCallLengthFlag ?
                    ` - ${callTableViewModel.filters.callFilters.callLengthMin === 0 ? 'No Min' :
                            callTableViewModel.filters.callFilters.callLengthMin === 3660 ? 'No Max' :
                            secondsToMinutes(callTableViewModel.filters.callFilters.callLengthMin)}
                        ${callTableViewModel.filters.callFilters.callLengthMin === callTableViewModel.filters.callFilters.callLengthMax ? '*' : ' : '+
                            (callTableViewModel.filters.callFilters.callLengthMax === 3660 ? 'No Max' :
                            secondsToMinutes(callTableViewModel.filters.callFilters.callLengthMax))}`
                    : ''
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <CallFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel} />
        </>
    )
}